/**
 * LogoFull Component
 *
 * Full-width THIS + THAT logo (964x164px) — single piece, no edge strips.
 * Cream fills baked into the SVG. Used when logo doors are still/closed.
 */

import React from 'react';
import SvgLogoDoorFullNew from './LogoDoorFullNew';

interface LogoFullProps {
  style?: React.CSSProperties;
}

const LogoFull: React.FC<LogoFullProps> = ({ style }) => (
  <SvgLogoDoorFullNew
    style={{
      position: 'absolute',
      left: 0,
      top: 0,
      width: 964,
      height: 164,
      pointerEvents: 'none',
      ...style,
    }}
  />
);

export default LogoFull;
